import { axiosClassic, axiosWithAuth } from '../api/interceprots'

export type ClientOs = 'ios' | 'android' | 'windows' | 'macos' | 'linux'

/** none — фронт строит deep-link сам; happ-crypt4 — зашифрованную ссылку отдаёт бэкенд */
export type LinkEncryption = 'none' | 'happ-crypt4'

/** Ответ GET /sub — стабильная ссылка-подписка текущего юзера. deep_link приходит при ?client= */
export interface SubLink {
	token: string
	url: string
	/** готовый deep-link под приложение (для happ-crypt4 — зашифрованный happ://crypt4/…) */
	deep_link?: string
}

/** Ссылка на скачивание приложения (магазин/сайт разработчика) */
export interface AppDownloadLink {
	url: string
	title: string
}

/** Элемент каталога GET /sub/apps?os=<os> (ClientAppDto) */
export interface ClientApp {
	os: string
	app_key: string
	title: string
	icon_url: string | null
	/** шаблон deep-link; null → у приложения нет авто-открытия (только копия/QR) */
	scheme_template: string | null
	/** формат тела подписки — нужен клиенту, фронт его не обрабатывает */
	body_format: string
	sort: number
	/** happ-crypt4 → deep-link строит бэкенд (шифрованный), фронт не подставляет URL сам */
	link_encryption: LinkEncryption
	/** ссылки на скачивание самого приложения (App Store/Google Play/сайт и т.п.) */
	download_links?: AppDownloadLink[]
}

export const SubService = {
	/**
	 * Ссылка-подписка текущего юзера (нужна авторизация). С client=<app_key> бэкенд возвращает
	 * готовый deep_link под приложение (для Happ — зашифрованный, чтобы юзер не видел конфиг).
	 */
	async getMyLink(client?: string) {
		const response = await axiosWithAuth.get<SubLink>(
			client ? `sub?client=${encodeURIComponent(client)}` : 'sub'
		)
		return response.data
	},
	/** Каталог приложений для ОС (публичный) */
	async getApps(os: ClientOs) {
		const response = await axiosClassic.get<ClientApp[]>(`sub/apps?os=${os}`)
		return response.data
	},
}
